// API URL helper - automatically detects correct backend URL based on current domain

export const getBackendUrl = () => {
  // Use environment variable first, fallback to current origin
  return process.env.REACT_APP_BACKEND_URL || window.location.origin;
};

export const API_URL = getBackendUrl();
